export class ReplaceShot {
  public ShotId: number;
  public ImgPath: string;
  public FileName: string;

  constructor(init?: Partial<ReplaceShot>) {
    Object.assign(this, init);
  }
}
